module.exports = __webpack_public_path__ + "img/agvania_yes.b2108d1a.png";